/**
 * all actions for funds summary state
 *
 * Created by Paul on 7/5/19
 */

import C from '../constants'


// action to hide/show the loader for funds list grid
export const showFundsListLoader = booleanVal => {
    return {
        type: C.SET_FUNDS_LIST_LOADER,
        payload: booleanVal
    }
}

// action to set the funds summary data
export const setFundsSummaryData = objectVal => {
    return {
        type: C.SET_FUNDS_SUMMARY_DATA,
        payload: objectVal
    }
}

// action to set the funds list data
export const setFundsListData = objectVal => {
    return {
        type: C.SET_FUNDS_LIST_DATA,
        payload: objectVal
    }
}


/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the funds summary saga (sagas/fundsSummarySaga.js)
export const getFundsSummaryData = () => {
    return {
        type: C.FETCH_FUNDS_SUMMARY_DATA
    }
}

export const getFundsListData = () => {
    return {
        type: C.FETCH_FUNDS_LIST_DATA
    }
}


// WEBPACK FOOTER //
// ./src/actions/fundsSummaryActions.js